import SaveIcon from "@mui/icons-material/Save";
import { useCallback } from "react";
import { useNotify, useRecordContext, useRedirect, useResourceContext, useUpdate } from "react-admin";
import { FieldValues, useFormContext } from "react-hook-form";
import ConfirmActionButton from "./ConfirmActionButton";

const SaveConfirmButton = ({ transformData }: { transformData?: (data: FieldValues) => FieldValues }) => {
  const resource = useResourceContext();
  const record = useRecordContext();
  const notify = useNotify();
  const redirect = useRedirect();
  const { getValues, trigger } = useFormContext();
  const [update, { isPending }] = useUpdate();

  // For save, we validate before open
  const triggerBeforeOpen = useCallback(async () => {
    const isValid = await trigger();
    return isValid;
  }, [trigger]);

  const handleSave = useCallback(() => {
    const data = getValues();
    update(
      resource,
      {
        id: record && record.id,
        data: transformData ? transformData(data) : data,
      },
      {
        onSuccess: () => {
          notify(`${resource} ID ${record && record.id} updated successfully`, { type: "success" });
          redirect("list", resource);
        },
        onError: () => {
          notify(`Error updating ${resource}`, { type: "error" });
        },
      },
    );
  }, [getValues, update, resource, record, notify, redirect, transformData]);

  return (
    <ConfirmActionButton
      label="Save"
      color="primary"
      variant="contained"
      startIcon={<SaveIcon />}
      action={handleSave}
      confirmTitle={`Save ${resource} ID ${record && record.id}`}
      confirmContent="Are you sure you want to save this item?"
      isPending={isPending}
      triggerBeforeOpen={triggerBeforeOpen}
    />
  );
};

export default SaveConfirmButton;
